import { FelaCSS, FelaCSSWithCustomSelectors, colors, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSSWithCustomSelectors;
  content: FelaCSS;
  controlsWrap: FelaCSS;
  rightWrap: FelaCSS;
  tagsOuter: FelaCSS;
  bookmarkedDate: FelaCSS;
  buttonWrap: FelaCSS;
  tagsWrap: FelaCSS;
  tagsLabel: FelaCSS;
  tag: FelaCSS;
  authorInfoAndShare: (withSubtitle?: boolean) => FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    position: 'relative',
    zIndex: 4,

    // overwrite react-sticky styles
    '> div > div.article-header-sticky': {
      left: '0 !important', // overwrite plugin inline style
      paddingTop: '0',
      paddingRight: spacing[5],
      paddingBottom: '0',
      paddingLeft: spacing[5],
      backgroundColor: colors.white,
      width: '100% !important', // overwrite plugin inline style
    },
  },

  content: {
    paddingTop: spacing[4],
    backgroundColor: colors.white,
    marginBottom: spacing[20],
    maxWidthMobile: {
      paddingHorizontal: spacing[0],
      marginBottom: spacing[0],
    },
  },

  controlsWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    paddingTop: spacing[1],
    paddingBottom: spacing[8],

    maxWidthTabletSm: {
      borderBottom: 'none',
      borderTop: `1px solid ${colors.dust}`,
      justifyContent: 'center',
      flexDirection: 'column',
      paddingTop: spacing[1],
      paddingBottom: spacing[4],
      maxWidthMobile: {
        paddingBottom: spacing[0],
      },
    },
  },

  rightWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidthTabletSm: {
      margin: `${spacing[3]} ${spacing[0]} ${spacing[4]} ${spacing[0]}`,
    },
  },

  bookmarkedDate: {
    fontDefaultSemiBold: 14,
    color: colors.mint,
    textAlign: 'right',

    maxWidthMobile: {
      display: 'none',
    },
  },

  tagsOuter: {
    flexDirection: 'row',
    alignItems: 'center',

    maxWidthTabletSm: {
      height: 'auto',
      alignItems: 'flex-start',
      justifyContent: 'center',
      marginBottom: spacing[0],
    },
  },

  buttonWrap: {
    marginLeft: spacing[3],
  },

  tagsWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: spacing[1],
  },

  tagsLabel: {
    fontDefaultSemiBold: 14,
    color: colors.silver,
  },

  tag: {
    color: colors.space,
    textTransform: 'capitalize',
    fontDefault: 14,
    backgroundColor: colors.indigoCrush04,
    borderRadius: '100px',
    paddingVertical: spacing[1],
    paddingHorizontal: spacing[4],
    ':hover': {
      textDecoration: 'none',
      color: colors.space,
      backgroundColor: colors.indigoCrush10,
    },
  },
  authorInfoAndShare: (withSubtitle) => ({
    paddingTop: '20px',
    flexDirection: withSubtitle ? 'column' : 'row',
    justifyContent: 'space-between',
    ...(withSubtitle && {
      gap: '20px',
    }),
    maxWidthMobile: {
      flexDirection: 'column',
    },
  }),
});

export default styles;
